import React from 'react'
import moment, { Moment } from 'moment'
import DayCell from './DayCell'
import { IScaleInterval, ICellConfig, ECellColor } from './calendarTypes'

interface IDayColumnProps {
  preview?: boolean
  colPos: number
  dayIntervals: IScaleInterval[]
  cellHeight: number
  cellWidth: number
  onSelectionStart(colPos: number, rowPos: number, day: moment.Moment): void
  onClick(colPos: number, rowPos: number): void
  onCellMouseEnter(colPos: number, rowPos: number): void
  minDay?: moment.Moment
  maxDay?: moment.Moment
  outsideRangeColor?: ECellColor
  cellConfigs: ICellConfig[]
  disabled?: boolean
  fontSize: string
}

const DayColumn: React.FC<IDayColumnProps> = ({
  preview,
  colPos,
  dayIntervals,
  cellHeight,
  cellWidth,
  onSelectionStart,
  onClick,
  onCellMouseEnter,
  minDay,
  maxDay,
  outsideRangeColor,
  cellConfigs,
  fontSize,
}) => {
  const findCellConfig = (start: Moment, end: Moment, searchDate: Moment) =>
    searchDate.isBetween(start, end, null, '[)')

  return (
    <div
      className="calendarBody__column"
      id={`calendar-body-column-${colPos}`}
      style={{
        width: cellWidth,
      }}
    >
      {dayIntervals.map((interval, rowPos) => {
        const cellConfig = cellConfigs.filter((cellConfig) =>
          findCellConfig(
            interval.start,
            interval.end,
            cellConfig.startTimestamp,
          ),
        )
        // const isCellDisabled = cellConfig?.length ? cellConfig[0].disabled : false
        let isOutsideRange = false
        if (minDay && interval.start.isBefore(minDay, 'day')) {
          isOutsideRange = true
        } else if (maxDay && interval.start.isAfter(maxDay, 'day')) {
          isOutsideRange = true
        } else if (interval.start.isBefore(moment())) {
          isOutsideRange = true
        }

        return (
          <div
            key={rowPos}
            className="calendarBody__cell"
            style={{
              height: cellHeight,
              zIndex: 1000,
              fontSize,
            }}
            // TODO: Turn this on again
            // onMouseOver={() => !isCellDisabled && onCellMouseEnter(colPos, rowPos)}
            onMouseOver={() => onCellMouseEnter(colPos, rowPos)}
          >
            <DayCell
              onMouseDown={() =>
                onSelectionStart(colPos, rowPos, interval.start)
              }
              onClick={() => onClick(colPos, rowPos)}
              cellConfigs={cellConfig}
              isOutsideRange={isOutsideRange}
              preview={preview}
              outsideRangeColor={outsideRangeColor}
            />
          </div>
        )
      })}
    </div>
  )
}

export default DayColumn
